import * as yup from 'yup'

const registerValidators = yup.object({
  email: yup.string().required('Email is required'),
})

export default registerValidators
